import { Card, Avatar, Badge } from "antd";
import React from "react";
import styled from "styled-components";

const StoreNameCardWrapper = styled.div`
  .ant-card-body {
    width: 400px;
  }

  .ahp-store-name-container {
    display: flex;
    align-items: center;
  }

  .ahp-store-name {
    font-size: 1rem;
    font-weight: 600;
    margin-left: 20px;
    line-height: 100%;
    vertical-align: middle;
  }

  .ant-badge {
    margin-left: 10px;
  }
`;

function StoreNameCard({ store, onClick, backgroundColor }) {
  return (
    <StoreNameCardWrapper>
      <Card
        hoverable
        size="small"
        onClick={onClick}
        style={{ backgroundColor: backgroundColor }}
      >
        <div style={{ display: "flex" }}>
          <Avatar size={64} src={store.main_image} />
          <div className="ahp-store-name-container">
            <div className="ahp-store-name">{store.name}</div>
            <Badge count={store.unread} />
          </div>
        </div>
      </Card>
    </StoreNameCardWrapper>
  );
}

export default StoreNameCard;
